import { Component, OnInit } from '@angular/core';
import { LaunchDarklyService } from '../context-discovery-services/services';
import { FeatureFlags } from '../context-discovery-services/constants/feature-flags.const';

@Component({
  selector: 'adminapp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  isUnifiedWorkflowEnabled: boolean = true;
  launchDarklySubscription: any;

  constructor(private ldService: LaunchDarklyService) {
    this.launchDarklySubscription = this.ldService.flagChange.subscribe(_ => {
      this.isUnifiedWorkflowEnabled = this.ldService.
        getBooleanFeatureFlagValue(FeatureFlags.UNIFIED_WORKFLOW, true);
    });
  }

  ngOnInit() {
    parent.postMessage('PreSalesTaskLoaded', '*');
  }
}
